import './style.css';
const API_URL = '/a/pbc-productwarnings/warnings-settings/';

window.pbcProductWarningsWidget = {
  getProductWarningsConfig: (productId) => {
      return fetch(API_URL + productId + '?url=' + window.location.href).then(response => response.json()).then(data => {
        if (data.data) {
          window.pbcProductWarningsWidget.renderWidget(data.data);
          window.pbcProductWarningsWidget.appendStyleVariables(data.data);
        }
      })
  },

  getCountry: async (warning) => {
    try {
      const response = await fetch('https://zu9x6litjj.execute-api.us-east-1.amazonaws.com/Prod/geo-data');
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      const data = await response.json();
      const countryCode = String(data.data.country);

      return countryCode;

    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
      return null;
    }
  },

  hideWarning: (warning, countryCode) => {
    const hideWarningCountries = warning.hideWarningOnCountries;
    const hideWarningTags = warning.hideWarningForCustomer.split(',').map(tag => tag.trim());
    const customerTags = PBC_CUSTOMER_TAGS ? PBC_CUSTOMER_TAGS.split(',').map(tag => tag.trim()) : [];

    const shouldHide = hideWarningCountries.some(country => country.value === countryCode);

    const checkForMatches = (hideWarningTags, customerTags) => {
      return hideWarningTags.some(tag => customerTags.includes(tag));
    };

    const matches = checkForMatches(hideWarningTags, customerTags);

    return matches || shouldHide;
  },

  showWarning: (warning, countryCode) => {
    const showWarningCountries = warning.showWarningOnCountries;
    const showWarningTags = warning.showWarningForCustomer.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
    const customerTags = PBC_CUSTOMER_TAGS ? PBC_CUSTOMER_TAGS.split(',').map(tag => tag.trim()) : [];

    const shouldShow = showWarningCountries.some(country => country.value === countryCode);

    if (customerTags.length === 0 && showWarningTags.length > 0) {
      return false;
    } else if (customerTags.length === 0 && showWarningTags.length === 0){
      return true;
    }

    const checkForMatches = (showWarningTags, customerTags) => {
      return showWarningTags.some(tag => customerTags.includes(tag));
    };

    const matches = checkForMatches(showWarningTags, customerTags);

    if (!showWarningCountries || showWarningCountries.length === 0) {
      return true;
    }

    return shouldShow && matches;
  },

  renderTextWarning: (warning) => {
    const targetElement = document.getElementById('pbcProductWarning');
    targetElement.innerHTML = `
        <div class="pbc-pw__content-text">
            <p class="pbc-pw__content-background"></p>
            <h2 class="pbc-pw__title">${warning.warningTitle}</h2>
            <div class="pbc-pw__content">${warning.warningContentEditor}</div>
        </div>
    `;
  },

  renderImageWarning: (warning) => {
    const targetElement = document.getElementById('pbcProductWarning');
    targetElement.innerHTML = `
        <div class="pbc-pw__content-image">
            <h2 class="pbc-pw__title">${warning.warningTitle}</h2>
            <img class="pbc-pw__image" src="${warning.contentImage.url}" alt="Warning image">
        </div>
    `;
  },

  renderHtmlWarning: (warning) => {
    const targetElement = document.getElementById('pbcProductWarning');
    targetElement.innerHTML = `
        <div class="pbc-pw__content-html">
            <div class="pbc-pw__html-content">${warning.warningHtml}</div>
        </div>
    `;
  },

  renderPopupWarning: (warning, productId) => {
    let warningOverlay = document.createElement('div')
    warningOverlay.classList.add('pbc-pw__content-popup-overlay')
    warningOverlay.id = 'pbc_pw--popup-overlay';

    document.body.insertAdjacentElement('afterbegin', warningOverlay);
    warningOverlay.innerHTML = `
          <div class="pbc-pw__content-popup">
              <button class="pbc_pw--closeButton" id="pbc_pw--closePopupButton">&#x2715;</button>
              <h2 class="pbc-pw__popup-title">${warning.warningTitle}</h2>
              <div class="pbc-pw__popup-content">${warning.warningContentEditor}</div>
              <button class="pbc-pw__confirm-btn" id="pbc_pw--confirmPopupButton">${warning.warningConfirmBtnText}</button>
              <button class="pbc-pw__cancel-btn" id="pbc_pw--cancelPopupButton">${warning.warningCancelBtnText}</button>
          </div>
    `;

    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    function checkCookie() {
      const cookieName = "pbc_pw--closePopup";
      const name = cookieName + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(';');
      for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) === 0) {
          return true;
        }
      }
      return false;
    }

    function checkPopup() {
      if (checkCookie()) {
        document.getElementById('pbc_pw--popup-overlay').style.display = 'none';
      } else {
        document.getElementById('pbc_pw--popup-overlay').style.display = 'flex';
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", checkPopup);
    } else {
      checkPopup();
    }

    function findFormWithSubmit() {
      const pbcPwFormButton = document.querySelector('form button[type="submit"]')?.closest('form');
      if (pbcPwFormButton) {
        const submitButton = pbcPwFormButton.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.setAttribute('disabled', 'disabled');
          submitButton.disabled = true;
        }

        const submitInput = pbcPwFormButton.querySelector('input[type="submit"]');
        if (submitInput) {
          submitInput.setAttribute('disabled', 'disabled');
          submitInput.disabled = true;
        }

        const addToCartButton = document.querySelector('.add-to-cart');
        const buyButton = document.querySelector('.buy-button');

        if (addToCartButton) {
          addToCartButton.setAttribute('disabled', 'disabled');
          addToCartButton.disabled = true;
        }

        if (buyButton) {
          buyButton.setAttribute('disabled', 'disabled');
          buyButton.disabled = true;
        }
      } else {
        console.log('Form with submit button not found.');
      }
    }

    if (warning.cancelBtnBehaviour.value === 'nothing') {
      document.getElementById('pbc_pw--cancelPopupButton').onclick = function() {
        document.getElementById('pbc_pw--popup-overlay').style.display = 'none';
        setCookie("pbc_pw--closePopup", "true", 7);
      };

      document.getElementById('pbc_pw--closePopupButton').onclick = function() {
        document.getElementById('pbc_pw--popup-overlay').style.display = 'none';
        setCookie("pbc_pw--closePopup", "true", 7);
      };

      document.getElementById('pbc_pw--confirmPopupButton').onclick = function() {
        document.getElementById('pbc_pw--popup-overlay').style.display = 'none';
        setCookie("pbc_pw--closePopup", "true", 7);
      };

    } else {
      document.getElementById('pbc_pw--cancelPopupButton').onclick = function() {
        document.getElementById('pbc_pw--popup-overlay').style.display = 'none';
        setCookie('canselPopup_' + productId, "true", 7);
        findFormWithSubmit()
      };

      document.getElementById('pbc_pw--confirmPopupButton').onclick = function() {
        document.getElementById('pbc_pw--popup-overlay').style.display = 'none';
        setCookie("pbc_pw--closePopup", "true", 7);
      };
    }
  },

  renderWidget: async (warning, productId) => {
    try {
      const currentCountryCode = await window.pbcProductWarningsWidget.getCountry(warning);
      const showWarningInfoExists = warning.showWarningForCustomer && warning.showWarningForCustomer.trim() !== '';
      const showWarningInfoCountries = warning.showWarningOnCountries && warning.showWarningOnCountries.length !== 0;

      let shouldShowWarning = false;

      if (showWarningInfoExists || showWarningInfoCountries) {
        shouldShowWarning = window.pbcProductWarningsWidget.showWarning(warning, currentCountryCode);
      } else {
        shouldShowWarning = true;
      }

      let shouldHideWarning = window.pbcProductWarningsWidget.hideWarning(warning, currentCountryCode);
      if (!shouldHideWarning && shouldShowWarning) {
        if (warning.warningType.value === 'text') {
          window.pbcProductWarningsWidget.renderTextWarning(warning);
        } else if (warning.warningType.value === 'popup') {
          window.pbcProductWarningsWidget.renderPopupWarning(warning);
        } else if (warning.warningType.value === 'html') {
          window.pbcProductWarningsWidget.renderHtmlWarning(warning);
        } else if (warning.warningType.value === 'image') {
          window.pbcProductWarningsWidget.renderImageWarning(warning);
        }
      }
    } catch (error) {
      console.error('Error rendering widget:', error);
    }
  },

  appendStyleVariables: (warning) => {
    let rootStyles = '';

    rootStyles += ':root{\n';

    rootStyles += '--pw-popupBackgroundColor: ' + warning.popupBackgroundColor + ';\n';
    rootStyles += '--pw-popupTextColor: ' + warning.popupTextColor + ';\n';
    rootStyles += '--pw-popupOverlayBackground: ' + warning.popupOverlayBackground + warning.popupOverlayOpacity + ';\n';
    rootStyles += '--pw-popupOverlayOpacity: ' + warning.popupOverlayOpacity + '%;\n';
    rootStyles += '--pw-confirmBtnBgColor: ' + warning.confirmBtnBgColor + ';\n';
    rootStyles += '--pw-confirmBtnBorderColor: ' + warning.confirmBtnBorderColor + ';\n';
    rootStyles += '--pw-confirmBtnBorderRadius: ' + warning.confirmBtnBorderRadius + 'px;\n';
    rootStyles += '--pw-confirmBtnTextColor: ' + warning.confirmBtnTextColor + ';\n';
    rootStyles += '--pw-confirmBtnFontSize: ' + warning.confirmBtnFontSize + 'px;\n';
    rootStyles += '--pw-confirmBtnFontWeight: ' + warning.confirmBtnFontWeight.value + ';\n';
    rootStyles += '--pw-cancelBtnBgColor: ' + warning.cancelBtnBgColor + ';\n';
    rootStyles += '--pw-cancelBtnBorderColor: ' + warning.cancelBtnBorderColor + ';\n';
    rootStyles += '--pw-cancelBtnBorderRadius: ' + warning.cancelBtnBorderRadius + 'px;\n';
    rootStyles += '--pw-cancelBtnTextColor: ' + warning.cancelBtnTextColor + ';\n';
    rootStyles += '--pw-cancelBtnFontSize: ' + warning.cancelBtnFontSize + 'px;\n';
    rootStyles += '--pw-cancelBtnFontWeight: ' + warning.cancelBtnFontWeight.value + ';\n';

    rootStyles += '--pw-contentBackground: ' + warning.contentBackground + ';\n';
    rootStyles += '--pw-contentBackgroundOpacity: ' + warning.contentBackgroundOpacity + '%;\n';
    rootStyles += '--pw-contentTextColor: ' + warning.contentTextColor + ';\n';
    rootStyles += '--pw-contentHeaderColor: ' + warning.contentHeaderColor + ';\n';
    rootStyles += '--pw-contentHeadingWeight: ' + warning.contentHeadingWeight.value + ';\n';
    rootStyles += '--pw-contentBorderColor: ' + warning.contentBorderColor + ';\n';
    rootStyles += '--pw-contentHeadingFontSize: ' + warning.contentHeadingFontSize + 'px;\n';
    rootStyles += '--pw-contentBorderWeight: ' + warning.contentBorderWeight + 'px;\n';
    rootStyles += '--pw-contentTextFontSize: ' + warning.contentTextFontSize + 'px;\n';
    rootStyles += '--pw-contentPaddingTop: ' + warning.contentPaddingTop + 'px;\n';
    rootStyles += '--pw-contentPaddingBottom: ' + warning.contentPaddingBottom + 'px;\n';
    rootStyles += '--pw-contentPaddingLeft: ' + warning.contentPaddingLeft + 'px;\n';
    rootStyles += '--pw-contentPaddingRight: ' + warning.contentPaddingRight + 'px;\n';
    rootStyles += '--pw-contentTextAlign: ' + warning.contentTextAlign.value + ';\n';
    rootStyles += '--pw-popupContentTextAlign: ' + warning.popupContentTextAlign.value + ';\n';

    rootStyles += '}'

    let styleVariables = document.createElement('style');
    styleVariables.id = 'pbcPwCssVariables';
    styleVariables.textContent = rootStyles;

    let globalStyles = document.createElement('link');
    globalStyles.rel = 'stylesheet';
    globalStyles.href = 'https://productwarnings.polarbearapps.com/frontend/style.css';

    if (process.env.ENVIRONMENT === 'dev') {
      globalStyles.href = 'https://productwarnings/frontend/style.css';
    } else if (process.env.ENVIRONMENT === 'stage') {
      globalStyles.href = 'https://productwarnings-staging.polarbearapps.com/frontend/style.css';
    }

    document.getElementsByTagName('head')[0].appendChild(styleVariables);
    document.getElementById('pbcPwCssVariables').after(globalStyles);
  },

  init: (productId) => {
    window.pbcProductWarningsWidget.getProductWarningsConfig(productId)
  }
}

let productWarningsWidget = document.getElementById('pbcProductWarning');
if (productWarningsWidget) {
window.pbcProductWarningsWidget.init(productWarningsWidget.dataset.productId);
}